// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

// Import firebase
import { supportCategoriesModel } from '@/firebase/firebase-config'

export const GetSupportCategories = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        categories: []

    }),

    /*
	**  Methods
    */
    
    methods: {

        getSupportCategoriesHandler: async function() {

            try {

                // Get the user doc
                supportCategoriesModel.where('meta.deleted_at', '==', null).get()
                .then(snapshot => {

                    if (snapshot.empty) return;

                    /*
                    **  Loop through the results and set the document
                    */

                    snapshot.forEach(doc => {

                        /*
                        **  Add to the prop
                        **  @prop_location: @here
                        */

                        this.categories.push(doc.data());

                    });

                })
                .catch(error => {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportNoAuthBugsnagError({
                        title: 'Get Support Categories from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Support',
                        uid: 'L0aWiphbRXsjhvL0ss36',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
               
                this.reportNoAuthBugsnagError({
                    title: 'Unable to Query Firestore When Getting the Support Categories.',
                    errorType: 'Firestore Database',
                    section: 'Events/Support',
                    uid: 'Q6eoF9jJyyiub2UMu0Ti',
                    error: e
                });

            }

        }

    }

}